import { call, put, all } from "redux-saga/effects";
import * as PersistenceEngine from "../persistence/engine";
import { shouldPersistAction } from "../persistence/whitelist";

export default function* loadSaga() {
  // Load the saved actions array from local storage
  const savedActions: { type: string; [key: string]: any } = yield call(
    PersistenceEngine.load
  );

  // TODO: Display loading until the last action is yielded
  yield all(
    Object.keys(savedActions)
      .map((key) => savedActions[key])
      .filter((x) => shouldPersistAction(x.type))
      .map((x) => put(x))
  );
}
